<div class="container-fluid" [attr.aria-label]="!user.requiresscreenreader ? language.questionNavigation : ''">
  <div *ngIf="!adminpaused && !proctorpaused" class="row mx-0">
    <div class="d-flex align-items-center justify-content-between w-100 py-2" style="height: 50px;">
      <div class="d-flex justify-content-start">
        <button *ngIf="!user.requiresscreenreader" type="button" [disabled]="qno <= 1" (click)="prevbtnclicked()"
          class="btn cornblue btn-responsive" [attr.aria-label]="language.previousQuestion">
          <i class="fa fa-long-arrow-left btn-text" aria-hidden="true"></i>
          <span class="btn-text">{{language.previous}}</span>
          <span class="btn-icon-only"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
        </button>
      </div>
      <div class="d-flex justify-content-center title-container">
        <h2 #questionTitle class="question-title" [title]="getQuestionTitle()"
          [attr.aria-label]="getQuestionAriaTitle()" tabindex="0">
          {{getQuestionTitle()}}
        </h2>
      </div>
      <div class="d-flex justify-content-end">

        <button *ngIf="showQuestionList"  type="button"  (click)="gotoQutionList()"
          class="btn btn-outline-secondary">{{language.questionList}}</button>
          
        <button type="button" *ngIf="!islast && !user.requiresscreenreader" (click)="nextbtnclicked()"
          class="btn cornblue btn-responsive" [attr.aria-label]="language.nextQuestion">
          <span class="btn-text">{{language.next}}</span> <i class="fa fa-long-arrow-right btn-text"
            aria-hidden="true"></i>
          <span class="btn-icon-only"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        </button>
        <button *ngIf="!adminpaused && !proctorpaused && (islast) && !user.requiresscreenreader" type="button"
          (click)="finishclicked()" class="btn btn-danger btn-responsive">
          <span class="btn-text">{{language.finishAndSubmit}}</span>
          <span class="btn-icon-only">{{language.finishAndSubmit}}</span>
        </button>
      </div>
    </div>
    <div class="sr-only" aria-live="polite">
      {{ islast ? language.youAreOnTheLastQuestion : '' }}
    </div>
  </div>
</div>